import BlockIcon from "@mui/icons-material/Block";
import { Tooltip } from "@mui/material";
import localisations from "domains/nodes/localisation";

const NoPartitionsAllowedTooltip = () => {
    return (
        <Tooltip title={localisations.nodeDetails.tooltips.noPartitionsAllowed}>
            <BlockIcon color="error" />
        </Tooltip>
    );
};

export default NoPartitionsAllowedTooltip;
